import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as eventLogActions from 'src/app/root-store/event-log-store/actions';
import { map, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from 'src/app/shared/components/custom-snackbar/custom-snackbar.component';

@Injectable()
export class EventLogStoreEffects {
  constructor(private actions$: Actions, private snackBar: MatSnackBar) {}

  info$ = createEffect(() =>
    this.actions$.pipe(
      ofType<eventLogActions.Info>(eventLogActions.ActionTypes.INFO),
      map((action) => {
        this.snackBar.open(
          typeof action.payload === 'string'
            ? action.payload
            : action.payload.alert,
          '',
          {
            duration: 5000,
            verticalPosition: 'bottom',
            horizontalPosition: 'left',
          }
        );

        return new eventLogActions.EmptyAction();
      })
    )
  );

  success$ = createEffect(() =>
    this.actions$.pipe(
      ofType<eventLogActions.Info>(eventLogActions.ActionTypes.SUCCESS),
      map((action) => {
        this.snackBar.open(
          typeof action.payload === 'string'
            ? action.payload
            : action.payload.alert,
          '',
          {
            duration: 5000,
            panelClass: 'success',
            verticalPosition: 'bottom',
            horizontalPosition: 'left',
          }
        );

        return new eventLogActions.EmptyAction();
      })
    )
  );

  warning$ = createEffect(() =>
    this.actions$.pipe(
      ofType<eventLogActions.Info>(eventLogActions.ActionTypes.WARNING),
      map((action) => {
        this.snackBar.open(
          typeof action.payload === 'string'
            ? action.payload
            : action.payload.alert,
          '',
          {
            duration: 5000,
            panelClass: 'warning',
            verticalPosition: 'bottom',
            horizontalPosition: 'left',
          }
        );

        return new eventLogActions.EmptyAction();
      })
    )
  );

  error$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<eventLogActions.Error>(eventLogActions.ActionTypes.ERROR),
        tap((action) => {
          this.snackBar.openFromComponent(CustomSnackbarComponent, {
            data: {
              title:
                typeof action.payload === 'string'
                  ? action.payload
                  : action.payload.alert,
              type: 'danger',
            },
            panelClass: 'danger',
            duration: 5000,
            horizontalPosition: 'start',
          });
        })
      ),
    { dispatch: false }
  );
}
